import {
    CModal,
    CButton,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CModalBody,
} from '@coreui/react';
import { FC } from 'react';

type confirmationBoxCallBackFunctionType = (paramOne: any) => void;

interface iConfirmationBoxModalProps {
    title: string;
    message: string;
    subMessage?: string;
    buttonOneText: string;
    buttonTwoText: string;
    buttonOneCallable: confirmationBoxCallBackFunctionType;
    buttonTwoCallable: confirmationBoxCallBackFunctionType;
    buttonOneCallBackFunctionParams: any;
    buttonTwoCallBackFunctionParams: any;
    onClose?: () => void;
}

const ConfirmationBoxModal: FC<iConfirmationBoxModalProps> = ({
    title,
    message,
    subMessage = '',
    buttonOneText,
    buttonTwoText,
    buttonOneCallable,
    buttonTwoCallBackFunctionParams,
    buttonTwoCallable,
    buttonOneCallBackFunctionParams,
    onClose,
}) => {
    return (
        <CModal scrollable visible={true} onClose={onClose ?? (() => {})}>
            <CModalHeader>
                <CModalTitle>{title}</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className="mb-2">
                    {message}
                    {subMessage && (
                        <div className="small fst-italic text-muted">
                            {subMessage}
                        </div>
                    )}
                </div>

                <CModalFooter>
                    <CButton
                        color="light"
                        onClick={() =>
                            buttonOneCallable(buttonOneCallBackFunctionParams)
                        }
                    >
                        {buttonOneText}
                    </CButton>
                    <CButton
                        color="secondary"
                        onClick={() =>
                            buttonTwoCallable(buttonTwoCallBackFunctionParams)
                        }
                    >
                        {buttonTwoText}
                    </CButton>
                </CModalFooter>
            </CModalBody>
        </CModal>
    );
};

export default ConfirmationBoxModal;
